import {transient, autoinject, inject, Lazy, Factory} from "aurelia-framework";
import { ValidationService, IValidationService } from "../validation/validation-service";
import { FormSchemaRulesProvider, IFormSchemaRulesProvider } from "./form-schema-rules-provider";
import { FormSchemaCollectionController, IFormSchemaCollectionController } from "./form-schema-collection-controller";
/**
 * factory class for FormSchemaCollectionController
 * 
 * Instatiate like this:
 *      constructor(
 *          factory: FormSchemaCollectionControllerFactory
 *      ) {}
 * 
 * Get your FormSchemaCollectionController like this:
 * 
 *  let yourController = factory.Create("yourWebserviceName");
 * 
 */
@inject(
    Lazy.of(ValidationService), 
    Lazy.of(FormSchemaRulesProvider), 
    Factory.of(FormSchemaCollectionController))
@transient()
export class FormSchemaCollectionControllerFactory {

    public constructor(
          private getValidationService: () => ValidationService
        , private getFormSchemaRulesProvider: () => FormSchemaRulesProvider
        , private getFormSchemaCollectionController: (webServiceName: string) => FormSchemaCollectionController<any>
    ) { }

    /**
     * Create a FormSchemaCollectionController.  
     * If you want to override any of the default services required by FormSchemaCollectionController, then register them for DI in the
     * container in which you instantiated this factory instance.
     * 
     * @param aureliaHelperService
     * @param webServiceName
     * @param validator
     */
    public Create<TInstance>(
        webServiceName: string
        , disableValidation:boolean = false): IFormSchemaCollectionController<TInstance> {

        // let formSchemaController: any = new FormSchemaCollectionController(
            // this.commonDialogs, 
            // this.sortColumnService, 
            // this.dialogService, 
            // this.notificationService, 
            // this.formSchemaService, 
            // this.formSchemaCrudService, 
            // webServiceName);

        let formSchemaController: any = this.getFormSchemaCollectionController(webServiceName);

        if (!disableValidation)
        {
            formSchemaController.rulesGenerator = this.getFormSchemaRulesProvider();
            formSchemaController.validationService = this.getValidationService();
        }

        return formSchemaController;
    }
}
